import PropTypes from 'prop-types'
import Modal from "components/elements/Modal";
import SignInUp from 'components/elements/SignInUp'
import './style.scss'
import { memo, useState } from 'react';

const SignInUpModal = ({
    closeModal,
    onSignUp,
    onSignIn,
    onForgetPassword,
    type
}) => {

    const [isLoading, setIsLoading] = useState(false)

    return (
        <Modal
            isHaveCloseIcon={false}
            closeModal={ () => {
                if(isLoading) return;
                closeModal()
            }}
            className='sign_in_up_wrapper'
        >
            <SignInUp
                closeModal={closeModal}
                onSignUp={onSignUp}
                onSignin={onSignIn}
                onForgetPassword={onForgetPassword}
                type={type}
                onLoadingChange={ setIsLoading }
            />
        </Modal>
    )
}

SignInUpModal.propTypes = {
    closeModal: PropTypes.func,
    onSignUp: PropTypes.func,
    onSignIn: PropTypes.func,
    onForgetPassword: PropTypes.func,
    type: PropTypes.string
}

export default memo(SignInUpModal)